<template>
	<div v-if="background" class="momo-preview">
		<div class="background-overlay"></div>
		<ul id="background" class="background" v-bind:style="{ backgroundImage: 'url(' + imageUrl + ')' }"></ul>

		<div class="widgets" style="opacity: 1">
			<div id="top-left">
				<div class="top-widget">
					<span class="toggle">Links</span>
				</div>
			</div>

			<div id="top-right">
				<div id="weather" class="metric weather" style="opacity: 1;" @click="showSettings = !showSettings">
					<div class="metric-stat">
						<span class="metric-stat-number">$10,000</span>
					</div>
					<span class="location metric-label data">Sales</span>
					<div class="app-metrics container-fluid" v-show="showSettings" :style="{'background': previewBackground, 'color': selectedColor.bodyTextColor }">
						<div class="row h-100 wrapper">
							<div class="col">
								<div class="row u--pl-10">
									<div class="col u--pt-10">
										<img src="../../../assets/img/icon-metric.svg" class="metric-icon"
											:style="{'filter': selectedColor.bodyTextColor === '#fff' || selectedColor.bodyTextColor === '#ffffff' ? 'brightness(0) invert(1)' : ''}"/>
										<span>Metrics</span>
									</div>
								</div>
								<div class="row u--pl-10">
									<div class="col u--pt-10">
										<div class="metric-stat">
											<span class="metric-stat-number">$10,000</span>
										</div>
										<span class="location metric-label data">Sales</span>
									</div>
								</div>
								<div class="row u--pl-10">
									<div class="col u--pt-10">
										<div class="metric-stat">
											<span class="metric-stat-number">5</span>
										</div>
										<span class="location metric-label data">Glasses of Water</span>
									</div>
								</div>
								<div class="row u--pl-10">
									<div class="col u--pt-10">
										<div class="metric-stat">
											<span class="metric-stat-number">1.623929</span>
										</div>
										<span class="location metric-label data">GBP:CAD</span>
									</div>
								</div>
								<div class="row u--pl-10">
									<div class="col u--pt-10">
										<div class="metric-stat">
											<span class="metric-stat-number">1,000</span>
										</div>
										<span class="location metric-label data">Steps</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="weather" class="metric weather" style="opacity: 1;">
					<div class="metric-stat">
						<span class="icon icon-weather" data-icon="Y" title="Cloudy"></span><span class="metric-stat-number">24</span><span class="weather-degree">°</span><span class="unit hide">c</span>
					</div>
					<span class="location metric-label data">Victoria</span>
				</div>
			</div>

			<div id="center">
				<div id="centerclock" style="opacity: 1;">
					<div class="clock default-clock">
						<h1 class="time">{{ time }}</h1>
					</div>
				</div>
				<div id="greeting" style="opacity: 1;">
					<h2>Good <span class="period">{{ period }}</span>, <span class="name">{{ userInfo.display_name }}</span>.</h2>
				</div>
			</div>

			<div id="center-below">
				<div id="center-below">
					<div id="focuses" style="opacity: 1;">
						<ol>
							<li class="focus" style="opacity: 1; display: list-item;">
								<h3>Today</h3>
								<p class="todays-focus">Don't worry, be happy</p>
							</li>
						</ol>
					</div>
				</div>
			</div>

			<div id="bottom">
				<blockquote class="quote" id="shortquote" style="opacity: 1;">
					<p class="quote-body">
						<span class="quote-body-text">“The champion wins in their mind first.”</span><i class="icon-angle-right"></i>
					</p>
				</blockquote>
			</div>

			<div id="bottom-left" class="bottom-left">
				<div class="app-settings container-fluid" v-show="showSettings" :style="{'background': previewBackground, 'color': selectedColor.bodyTextColor, '--text-color': selectedColor.bodyTextColor }">
					<div class="row h-100">
						<div class="col-3 u--vertical-line padding-nav-text">
							<div class="row">
								<ul class="col right-nav">
									<li :class="{active: tab === 'general'}" @click="tab = 'general'" title="keyboard shortcut: g">General</li>
									<li :class="{active: tab === 'colors'}" @click="tab = 'colors'"  title="keyboard shortcut: c">Colors</li>
									<li :class="{active: tab === 'destination'}" @click="tab = 'destination'"  title="keyboard shortcut: d">Destination</li>
									<li>Mantras</li>
									<li>Photos</li>
									<li>Quotes</li>
									<li>Links</li>
									<li>Balance</li>
									<li v-if="position"><h2>{{ position }}</h2></li>
								</ul>
							</div>
						</div>
						<form class="col-9">
							<div class="row u--pt-10" v-if="!submission">
								<div class="col-10">
									<span class="u--small-06-opacity"> Saved <timeago :auto-update="true" :datetime="background.modified"></timeago></span>
								</div>
								<div class="col-2">
									<button @click.prevent="save" class="save-button" :class="{ 'save-button--dirty': somethingChanged }" :title="somethingChanged ? 'Save changes' : 'No changes to save'" :style="{'color': selectedColor.bodyTextColor }"><i class="fa fa-save" :class="{ 'fa-spinner fa-spin': saving }"/></button>
								</div>
							</div>
							<div :class="submission ? 'u--pt-10' : 'u--pt-0'" class="row detail-row detail-row-active detail-row-info" >
								<div class="col">
									<h3>
										<input v-if="mode === 'submissions'" class="no-input" v-model="background.approved_location" @focus="inputFocused = true" @blur="inputFocused = false"/>
										<input v-else class="no-input" v-model="background.title" @focus="inputFocused = true" @blur="inputFocused = false"/>
									</h3>
									<input class="no-input" v-model="background.source" @focus="inputFocused = true" @blur="inputFocused = false"/>
									<input class="no-input" v-model="background.photographer_name" disabled/>
								</div>
							</div>
							<div v-show="tab === 'general' && !submission">
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15" @click="toggleActive">
										Active/Approve
										<span class="switch" :class="{ 'on': background.active }"></span>
									</div>
								</div>
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										Notes
										<textarea @focus="inputFocused = true" style="color: inherit !important;" type="text" name="notes" v-model="background.notes" @blur="inputFocused = false"></textarea>
									</div>
								</div>
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										Photo Backlink
										<input class="no-input u--pt-2" v-model="background.sourceUrl" @focus="inputFocused = true" @blur="inputFocused = false"/>
									</div>
								</div>
								<div class="row" v-if="background.photographer_email">
									<div class="col detail-row detail-row-active u--pl-15">
										Submitter Email
										<input class="no-input u--pt-2" v-model="background.photographer_email" disabled/>
									</div>
								</div>
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										<span v-if="promptForDelete">Are you sure?
											<button class="prompt-button" @click.prevent="deleteBackground">Yes</button>
											<button class="prompt-button" @click.prevent="promptForDelete = false">No</button>
										</span>
										<span v-else>Delete</span>
										<span class="switch switch-delete" :class="{ 'on': background.deleted }" @click="promptForDelete = true"></span>
									</div>
								</div>
							</div>
							<div v-show="tab === 'general' && submission">
								<div class="row">
									<div class="col detail-row detail-row-active u--cursor u--pl-15" @click.prevent="approveAndFeature">
										Approve and Feature <i class="fa fa-check"/>
									</div>
								</div>
							</div>
							<div v-show="tab === 'colors'">
								<div class="row u--pt-10 detail-row detail-row-active u--pb-0">
									<div class="col">
										<contrast-ratio :selected-color="selectedColor" @hsl-focused="handleInputFocused" @open-eyedropper="selectColorViaEyeDropper"></contrast-ratio>
									</div>
								</div>
								<div class="row u--pt-10 detail-row detail-row-active u--pb-0">
									<div class="col">
										<hue-slider :selected-color="selectedColor" :unsaved="hueUnsaved && !somethingChanged" @commit="commitHue"></hue-slider>
									</div>
								</div>
								<div class="row u--pt-10 detail-row detail-row-active">
									<div class="col">
										<div class="row">
											<div class="col-9 saved-colors-title">
												Saved Colors <span class="u--small-06-opacity">(double click color to edit)</span>
											</div>
											<div class="col">
												<button class="add-button" title="Add to saved colors" @click.prevent="addToSavedColors(selectedColor)"><i class="fa fa-plus"></i></button>
												<button class="add-button" title="Remove from saved colors" @click.prevent="removeFromSavedColor(selectedColor)"><i class="fa fa-minus"></i></button>
											</div>
										</div>
										<draft-colors :background="background" :selected-color="selectedColor" :submission="submission" :picker-active="pickerDraftActive" @picker-active="setPickerDraftActive" @color-change="colorChange"></draft-colors>
									</div>
								</div>
								<div class="row u--pt-10 detail-row detail-row-active">
									<div class="col">
										Color Thief <span class="u--small-06-opacity">(double click color to edit)</span>
										<color-palette :variant="'ColorTheif'" :background="background" :selected-color="selectedColor" :submission="submission" :picker-active="pickerThiefActive" @picker-active="setPickerThiefActive" @color-change="colorChange"></color-palette>
									</div>
								</div>
							</div>
							<div v-show="tab === 'destination'">
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										Destination Name
										<input class="no-input u--pt-2" v-model="background.destination_name" @focus="inputFocused = true" @blur="inputFocused = false"/>
									</div>
								</div>
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										<div class="airport-code">
											Destination Airport Code (IATA Format: XXX)
											<a :href="searchURL" title="Search for nearest airport" target="_blank" rel="noopener noreferrer"><i class="fa fa-search"></i></a>
											<a :href="flightURL" title="Find flights" target="_blank" rel="noopener noreferrer"><i class="fa fa-plane"></i></a>
										</div>
										<input class="no-input u--pt-2" v-model="background.nearest_airport" @focus="inputFocused = true" @blur="inputFocused = false"/>
									</div>
								</div>
								<div class="row">
									<div class="col detail-row detail-row-active u--pl-15">
										Destination Information Link
										<input class="no-input u--pt-2" v-model="background.flight_link" @focus="inputFocused = true" @blur="inputFocused = false"/>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div id="preferences" class="preferences">
					<span @click="showSettings = !showSettings" class="toggle"><i class="ion-gear-a toggle-icon"  title="keyboard shortcut: space to quick hide. , to hide"></i></span>
				</div>
				<!--
				-->
				<div id="background-info" class="background-info" style="opacity: 1;" @click.prevent="sourceClicked">
					<span class="background-info-title" style="z-index: 2;">{{ (mode == 'submissions') ? background.approved_location : background.title }}<i class="icon-angle-right"></i></span>

					<span class="background-info-source">
						<span class="background-info-source-link">{{ (mode=='submissions') ? background.photographer_name : background.attribution }}</span>
					</span>
				</div>
			</div>

			<div id="bottom-right">
				<div id="todo" class="widget-bottom-right todo">
					<span class="toggle todo-toggle">Todo</span>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

import ColorPalette from '../backgrounds/ColorPalette'
import ContrastRatio from './ContrastRatio'
import DraftColors from './DraftColors'
import HueSlider from './HueSlider'
import util, { NO_COLOR } from '@/util'
import * as Vibrant from 'node-vibrant'

export default {
	name: 'preview',

	store: ['userInfo', 'preview', 'backgrounds', 'submissions'],

	components: { ColorPalette, ContrastRatio, DraftColors, HueSlider },

	data() {
		return {
			activeId: null,
			mode: this.$router.currentRoute.path.split('/')[1],
			showSettings: true,
			selectedColor: util.deriveColorFromHsla(NO_COLOR),
			inputFocused: false,
			saving: false,
			tab: null,
			pickerDraftActive: false,
			pickerThiefActive: false,
			baseline: null,
			awaitingInitialColor: true,
			hueUnsaved: false,
			hueCommitted: false,
			background: null,
			promptForDelete: false,
		}
	},

	computed: {
		imageUrl() {
			let backgroundUrl = this.background.download_url ? this.background.download_url : this.background.large_url
			if (!backgroundUrl) backgroundUrl = this.background.preview_url ? this.background.preview_url : this.background.thumbnail_url
			if (!backgroundUrl) backgroundUrl = `https://content.momentumdash.com/fullsize/${this.background.background_guid}.jpg`
			return backgroundUrl
		},

		position() {
			let indexOfBackground = this.images.findIndex(x => x.id === this.background.id)
			return `${indexOfBackground + 1}/${this.images.length}`
		},

		submission () {
			return this.mode.toUpperCase() === 'SUBMISSIONS'
		},

		images() {
			return this.submission ? this.submissions : this.backgrounds
		},

		time() {
			let now = new Date()
			let hour = now.getHours()
			let minute = now.getMinutes()
			hour = ((hour + 11) % 12 + 1)
			if (minute < 10) minute = "0" + minute
			return hour + ':' + minute
		},

		period() {
			let now = new Date()
			let hour = now.getHours()
			if (hour >= 3 && hour < 12) return 'morning'
			if (hour >= 12 && hour < 17) return 'afternoon'
			if (hour >= 17 || hour < 3) return 'evening'
			return ''
		},

		searchURL() {
			return `https://www.rome2rio.com/map/Victoria,BC,Canada/${this.background.title})}`
		},

		flightURL() {
			return `https://www.skyscanner.net/transport/flights/XXX/${this.background.nearest_airport}`
		},

		previewBackground() {
			// Stored colors are opaque; the editor preview owns its translucency so a
			// hint of the photo shows through the settings panels.
			const hsl = this.selectedColor && this.selectedColor.hsl
			const [h, s, l] = Array.isArray(hsl) && hsl.length === 3 ? hsl : [0, 0, 50]
			return `hsla(${h}, ${s}%, ${l}%, 0.95)`
		},

		// The form is dirty when its current state diverges from the baseline captured
		// once the photo and its initial color finished loading — so every field edit
		// (title, notes, color, hue, toggles, …) lights up the save button and arms the
		// unsaved-changes close warning. Committing an auto-derived hue dirties directly,
		// since the derived value is already in memory and wouldn't show as a diff.
		somethingChanged() {
			if (this.hueCommitted) return true
			if (this.baseline === null || !this.background) return false
			return this.serializeForm() !== this.baseline
		},
	},

	created() {
		window.addEventListener('keyup', this.handleKeyup)
		window.addEventListener('keydown', this.handleKeydown)
		this.tab = this.submission ? 'general' : 'colors'
		this.getImage()
	},

	destroyed: function(){
		window.removeEventListener('keyup', this.handleKeyup)
		window.removeEventListener('keydown', this.handleKeydown)
	},

	watch: {
		'$route.params.id'() {
			this.getImage()
		},

		// The Verte color picker (opened by double-clicking a swatch) mutates only
		// selectedColor.hsla in place, never routing through colorChange/deriveColorFromHsla.
		// Backfill the dependent fields (hsl/rgba/hex/bodyTextColor/hue/contrastRatio) so the
		// preview, save payload and hue stay consistent. The colorChange/HueSlider/ContrastRatio
		// paths already set hsl alongside hsla, so the cheap guard makes this a no-op for them.
		'selectedColor.hsla'(hsla) {
			const parsed = util.parseHsla(hsla)
			const hsl = this.selectedColor && this.selectedColor.hsl
			if (parsed && Array.isArray(hsl) &&
				Math.round(parsed.h) === hsl[0] && Math.round(parsed.s) === hsl[1] && Math.round(parsed.l) === hsl[2]) {
				return
			}
			const derived = util.deriveColorFromHsla(hsla)
			Object.keys(derived).forEach(key => this.$set(this.selectedColor, key, derived[key]))
		},
	},

	methods: {

		handleKeydown(e){
			if (this.inputFocused) return;
			switch (e.keyCode) {
				case 32: // space
					this.showSettings = false
					break
				case 83: // s
					if (e.metaKey) {
						this.save()
						e.preventDefault()
					}
					break
			}
		},

		handleKeyup(e) {
			if (this.inputFocused) return;
			switch (e.keyCode) {
				case 27: // esc
					if (this.pickerActive) this.pickerActive = false
					this.hide()
					break
				case 39: // left
					this.backgroundCycle()
					break
				case 37: // right
					this.backgroundCycle(false)
					break
				case 188: // ,
					this.showSettings = !this.showSettings
					break
				case 32: // space
					this.showSettings = true
					break
				case 71: // g
					this.tab = 'general'
					break
				case 67: // c
					this.tab = 'colors'
					break
				case 68: // d
					this.tab = 'destination'
					break
				case 65: // a
					this.addToSavedColors(this.selectedColor)
					break
				case 8: // backspace
					this.removeFromSavedColor(this.selectedColor)
					break
				case 69: // e
					this.selectColorViaEyeDropper()
					break
			}
		},

		hide() {
			if (this.somethingChanged) {
				if (window.confirm('You have unsaved changes! Are you sure you want to close Preview?')) {
					this.preview.show = false
					this.$emit('viewClosed')
				} else {
					return
				}
			}
			this.preview.show = false
			this.$emit('viewClosed')
		},

		backgroundCycle(forward = true) {
			this.pickerDraftActive = false
			this.pickerThiefActive = false
			const currentBackgroundIndex = this.images.findIndex(x => x.id === this.background.id)
			let newIndex = 0
			if (forward) {
				newIndex = currentBackgroundIndex + 1
				newIndex = newIndex > this.images.length - 1 ? this.images.length - 1 : newIndex
			} else {
				newIndex = currentBackgroundIndex - 1
				newIndex = newIndex < 0 ? 0 : newIndex
			}
			const oldActiveId = this.$route.params.id
			const newActiveId = this.submission ? this.images[newIndex].id : this.images[newIndex].background_guid
			if (oldActiveId !== newActiveId) {
				this.$router.push({ query: { filter: this.$route.query.filter }, params: {id : newActiveId }})
			}
		},

		colorChange(event) {
			// Normalize whatever was picked (palette swatch, saved color, eyedropper)
			// into a complete, consistent color object. deriveColorFromHsla backfills
			// hsl/rgba/hex/bodyTextColor/contrastRatio and the derived hue, so the hue
			// rides along in widget_color on save. The spread keeps the swatch's name.
			this.selectedColor = { ...event, ...util.deriveColorFromHsla(event && event.hsla) }
			this.background.widget_color = this.selectedColor
			// For a photo with no stored color, the palette's first emission IS the initial
			// state (not a user edit), so snapshot it as the baseline once saved_colors settles.
			// Photos with a stored color already captured their baseline at load, so this is skipped.
			if (this.awaitingInitialColor) {
				this.awaitingInitialColor = false
				this.$nextTick(() => { this.baseline = this.serializeForm() })
			}
		},

		toggleActive() {
			this.background.active = !this.background.active
		},

		deleteBackground() {
			this.$http.delete('/backgrounds/' + this.background.id)
				.then(function() {
					this.background.deleted = true
					this.hide()
				})
				.catch((error) => {
					console.log(error)
				})
		},

		sourceClicked() {
			window.open(this.background.sourceUrl, '_blank')
		},

		async save() {
			this.saving = true
			try {
				const state = this.savableState()
				let data = {
					title: state.title,
					notes: state.notes,
					active: state.active,
					widget_color: JSON.stringify(state.widget_color),
					source: state.source,
					saved_colors: JSON.stringify(state.saved_colors),
					source_url: state.sourceUrl,
					destination_name: state.destination_name,
					nearest_airport: state.nearest_airport,
					destination_info_url: state.flight_link,
				}

				const url = this.submission ? '/submissions/' + this.background.id : '/backgrounds/' + this.background.id
				await this.$http.patch(url, data)

				let image = this.images.find(x => x.background_guid === this.background.background_guid)
				image.widgetColor = this.selectedColor
				image.modified = this.background.modified = Date.now()

				this.hueUnsaved = false
				this.hueCommitted = false
				this.baseline = this.serializeForm()
			} catch (error) {
				console.error(error)
			}
			finally {
				this.saving = false
			}
		},

		handleInputFocused(focused) {
			this.inputFocused = focused
		},

		addToSavedColors(color) {
			let copiedColor = Object.assign({}, color)
			copiedColor.name = `${color.name}-${Math.floor(Math.random() * 99)}`
			this.background.saved_colors.pop()
			const index = this.background.saved_colors.findIndex(x => x.hsla === NO_COLOR)
			if (index === -1) this.background.saved_colors.push(copiedColor)
			else this.background.saved_colors.splice(index, 0, copiedColor)
			this.selectedColor = copiedColor
		},

		removeFromSavedColor(color) {
			const index = this.background.saved_colors.findIndex(x => x.name === color.name)
			const fillColor = { name:color.name, hsla: NO_COLOR}
			this.background.saved_colors.splice(index, 1, fillColor)
			this.colorChange(fillColor)
		},

		getBackground() {
			this.$http.get(`/background?uuid=${this.$route.params.id}`)
				.then((response) => {
					this.background = response.data
					this.initializeFromStoredColor()
				})
				.catch((error) => {
					console.log(error)
				})
		},

		getSubmission() {
			this.background = this.submissions.find(x => { return x.id === this.$route.params.id })
			this.initializeFromStoredColor()
		},

		getImage() {
			this.baseline = null
			this.awaitingInitialColor = true
			this.hueCommitted = false
			this.hueUnsaved = false
			this.selectedColor = util.deriveColorFromHsla(NO_COLOR)
			this.submission ? this.getSubmission() : this.getBackground()
		},

		parseWidgetColor(widgetColor) {
			if (!widgetColor || widgetColor === 'null') return null
			if (typeof widgetColor === 'string') {
				try { return JSON.parse(widgetColor) } catch (e) { return null }
			}
			return widgetColor
		},

		// Seed the editor from the photo's stored color and snapshot the dirty baseline the
		// moment the record loads — before the (async) color palette resolves. Otherwise an
		// edit made during palette load would be folded into the baseline and read as clean,
		// silently defeating the save button and the unsaved-changes close warning. Photos
		// with no stored color have no initial color until the palette picks one, so they keep
		// awaitingInitialColor=true and re-baseline on that first color-change.
		initializeFromStoredColor() {
			if (!this.background) return
			this.hueUnsaved = this.storedHueMissing(this.background.widget_color)
			const stored = this.parseWidgetColor(this.background.widget_color)
			if (stored && stored.hsla) {
				this.selectedColor = { ...stored, ...util.deriveColorFromHsla(stored.hsla) }
				this.awaitingInitialColor = false
			}
			this.baseline = this.serializeForm()
		},

		// Single source of truth for the savable form fields, consumed by BOTH serializeForm()
		// (dirty-tracking) and save() (the PATCH payload) so the two can't drift out of sync.
		// `title` resolves the mode-specific field; saved_colors is left raw here (save needs
		// it as-is) and normalized by serializeForm for comparison.
		savableState() {
			return {
				title: this.submission ? this.background.approved_location : this.background.title,
				notes: this.background.notes,
				active: this.background.active,
				source: this.background.source,
				sourceUrl: this.background.sourceUrl,
				destination_name: this.background.destination_name,
				nearest_airport: this.background.nearest_airport,
				flight_link: this.background.flight_link,
				widget_color: this.selectedColor,
				saved_colors: this.background.saved_colors,
			}
		},

		// Dirty-tracking snapshot. saved_colors is normalized (it may still be a raw JSON
		// string before DraftColors materializes it) so its shape can't cause a spurious diff.
		serializeForm() {
			if (!this.background) return ''
			const state = this.savableState()
			let savedColors = state.saved_colors
			if (typeof savedColors === 'string') {
				try { savedColors = JSON.parse(savedColors) } catch (e) { savedColors = [] }
			} else if (!Array.isArray(savedColors)) {
				savedColors = util.defaultSavedColors()
			}
			return JSON.stringify({ ...state, saved_colors: savedColors })
		},

		// The curator clicked the hue slider's "auto-derived" hint to accept it. The value
		// is already in selectedColor, so just dirty the form to enable saving it.
		commitHue() {
			this.hueCommitted = true
		},

		// A saved photo with a real (non-grey) accent but no stored hue predates the hue
		// system. The hue is auto-derived from the accent in memory on load; this flags
		// the photo so the slider can offer a one-click commit. Grey/empty photos have no
		// meaningful hue, so they're not flagged.
		storedHueMissing(widgetColor) {
			if (!widgetColor || widgetColor === 'null') return false
			let parsed = widgetColor
			if (typeof widgetColor === 'string') {
				try { parsed = JSON.parse(widgetColor) } catch (e) { return false }
			}
			if (!parsed || parsed.hue != null) return false
			const hsl = util.parseHsla(parsed.hsla)
			return !!(hsl && hsl.s > 0)
		},

		approveAndFeature() {
			this.$http.patch('/submissions/' + this.background.id + '/status', { status: 'featured' })
				.then((response) => {
					this.backgroundCycle()
					if (response && response.data)
					{
						let responseData = response.data;
						if(responseData.internal_short_status && responseData.internal_status_label)
						{
							this.background.internal_short_status = responseData.internal_short_status
							this.background.internal_status_label = responseData.internal_status_label
						}
					}
				})
				.catch((error) => {
					console.log(error)
				})
		},

		setPickerDraftActive(active) {
			this.pickerDraftActive = active
		},

		setPickerThiefActive(active) {
			this.pickerThiefActive = active
		},

		selectColorViaEyeDropper() {
			// eslint-disable-next-line
			const eyeDropper = new EyeDropper()
			eyeDropper.open()
				.then(colorSelectionResult => {
					const rgb = Vibrant.Util.hexToRgb(colorSelectionResult.sRGBHex)
					const hsl = Vibrant.Util.rgbToHsl(rgb[0], rgb[1], rgb[2])
					const hsla = `hsla(${Math.round(Number(hsl[0])*360)}, ${Math.round(Number(hsl[1])*100)}%, ${Math.round(Number(hsl[2])*100)}%, 0.95)`
					this.colorChange({ ...this.selectedColor, hsla })
				})
				.catch((error) => {
					console.error(error)
				})
		},
	}
}

</script>



<style scoped>
	/* settings */
	.app-settings { --sidebar-width: 180px; height: 450px; width: 700px; max-width: none; padding: 0; z-index: 10000; min-width: 200px; position: absolute; z-index: 2;
					border-radius: 5px; overflow-x: hidden; overflow-y: auto; text-align: left; text-shadow: none; box-sizing: border-box; bottom: 50px; left: 7px; background: black; }

		.right-nav { padding-left: 40px; padding-top: 15px }
			.right-nav li { padding-top: 10px; cursor: pointer; opacity: 0.6; }
				.right-nav .active { color: var(--text-color); font-weight: bolder; opacity: 1; }

			.no-input { padding: 0; border: none; color: var(--text-color); width: 100%; }

			.saved-colors-title { margin-right: 23px; }

			.add-button { background: transparent; color: var(--text-color); padding: 5px; margin: -5px; margin-left: 11px; }

			.save-button { background: transparent; color: var(--text-color); padding: 5px; margin: -5px; margin-left: 11px; font-size: 1.5em; opacity: 0.4; cursor: default; transition: opacity 0.2s ease; }
				.save-button--dirty { opacity: 1; cursor: pointer; }

			.prompt-button { background: transparent; color: var(--text-color); padding: 5px; margin: -5px; margin-right: 5px; font-size: 1.1em; }
			.switch-delete { background: #CC361D; }

			.airport-code a { margin-left: 5px; }

	.app-metrics { --sidebar-width: 180px; height: 270px; max-width: none; padding: 0; z-index: 10000; min-width: 200px; position: absolute; z-index: 2;
					border-radius: 5px; overflow-x: hidden; overflow-y: auto; text-align: left; text-shadow: none; box-sizing: border-box; top: 60px; right: 7px; background: black; }
		.app-metrics .wrapper { padding: 10px 0 0 10px; }
		.app-metrics .metric-icon { height: 17px; margin-right: 8px; opacity: .7; }

	.detail-row { border: 1px solid rgba(255, 255, 255, 0.09);}
		.detail-row-info { border-top: none; }
			.detail-row-info h3 { margin-bottom: 4px; margin-top: 4px; font-weight: 500; }
	.detail-row:hover { opacity: 1; }
		.detail-row .switch { right: 30px !important}

	.u--vertical-line { border-right: 1px solid rgba(255, 255, 255, 0.09); height: 100%; }
	.u--pt-10 { padding-top: 10px; }
	.u--pt-2 { padding-top: 2px; }
	.u--pt-0 { padding-top: 0; }
	.u--pb-0 { padding-bottom: 0; }
	.u--pl-10 { padding-left: 10px; }
	.u--pl-15 { padding-left: 15px; }
	.u--small-06-opacity { font-size: 0.8em; opacity: 0.6; }

	.h-100 { height: 100%; }

	.momo-preview { position: fixed; z-index: 1000000; }

	/* Momentum Dashboard */
	html { height: 100%; }
	body { height: 100%; min-height: 100%; margin: 0; overflow: hidden; background: #fff; color: #fff; font-size: 1em; text-shadow: 0px 1px 5px rgba(0,0,0,0.1); }
	body, input, select, textarea, button { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; }

	ul, ol { margin: 0; padding: 0; list-style: none; }
	a { color: inherit; outline: none; text-decoration: none; }
	input, select, textarea { font-family: inherit; }
	input, textarea { margin: 0; background: none; font-size: 100%; }
		input::-webkit-input-placeholder, textarea::-webkit-input-placeholder { color: #fff; opacity: 0.6; }
	i { font-style: normal; }


	/* Common */

	/* Adds a shadow behind the element - used for metrics */
	.add-shadow:before { position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; background: #000; border-radius: 40%; border-bottom-right-radius: 20%; content: ''; -webkit-filter: blur(25px); opacity: 0.25; }
		.metric.add-shadow:before { top: 14px; right: 20px; }



	/* Overlay */

	.drop {  }
		.drop .background { -webkit-filter: blur(3px); }
		.drop .widgets { -webkit-filter: blur(15px); }
		.drop-overlay { position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 1000000; display: none; align-items: center; flex-direction: column; justify-content: center; background: rgba(0,0,0,0.25); font-size: 240%; }
			.drop .drop-overlay { display: flex; }
			.drop-overlay .plus-badge { margin-top: -3px; margin-left: 2px; padding: 2px 6px 1px; font-size: 45%; vertical-align: middle; }


	/* Loading Screen */

	.loading-container { position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 0; display: flex; align-items: center; justify-content: center; }
	.loading-logo { height: 70px; margin-top: -10px; opacity: 0; -webkit-animation: fadein 1s linear 1s forwards; }



	/* Regions */

	.widgets, #background { position: fixed; top: 0; left: 0; bottom: 0; right: 0; }
	.widgets { z-index: 10; color: #fff; opacity: 0; }

	#full { height: 100%; }

	#top-left, #top-right, #bottom-right, #bottom, #bottom-left, #center, #center-below, #center-above { position: absolute; z-index: 3; }

	#center, #center-below, #center-above { display: block; top: 50%; left: 50%; width: 100%; text-align: center; -webkit-transform: translate(-50%,-50%); }

	#center { z-index: 4; }

	#bottom { width: 50%; bottom: 0; left: 50%; opacity: 1; -webkit-transform: translateX(-50%); }

	#top-right { top: 0; right: 0; z-index: 1000; }
	#top-left { top: 0; left: 0; }
	#bottom-right { bottom: 0; right: 0; z-index: 1000; }
	#bottom-left { bottom: 0; left: 0; z-index: 100; }

	#center-below, #center-above { left: 0; top: 72.5%; -webkit-transform: translate(0,0); text-align: center; }
	#center-above { top: 0; z-index: 1; }

	.top-widget { display: inline-block; vertical-align: top; }
	.widget-bottom-right { position: relative; display: inline-block; text-align: right; }



	/* Quote and Background Skip & Favourites Icons */

	.icon-refresh { }
		.active > .icon-refresh { animation: refresh 0.8s infinite; }

	.icon-heart { opacity: 0; -webkit-transform: scale(0.5); }
		.active > .icon-heart { opacity: 1; -webkit-transform: scale(1); -webkit-transition: -webkit-transform 0.25s cubic-bezier(.51,.23,.6,1.9), opacity 0.25s ease; }
	.icon-heart-empty { opacity: 1; }
		.active > .icon-heart-empty { opacity: 0; -webkit-transition: opacity 0.5s ease; }



	/* Background */

	#background, #background li { background-color: black; background-size: cover; background-position: center center; background-repeat: no-repeat; }
	#background { margin: 0; padding: 0; z-index: 1; }
	#background li { background-color: transparent; background-size: cover; background-position: center center; background-repeat: no-repeat; opacity: 0; }

	.background-overlay { position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 2; background: url('../../../assets/img/overlay-vignette.png'); background-size: 100% 100%; }



	/* Widgets */

	.list-borders:after, .list-borders:first-child:before { height: 1px; position: absolute; bottom: 0; left: 15px; right: 15px; background: rgba(255,255,255,0.15); content: ' '; }
		.list-borders:first-child:before { top: 0; bottom: auto; }

	.metric { padding: 14px 20px 0 0; position: relative; display: inline-block; cursor: default; font-size: 100%; text-align: right; -webkit-user-select: none; vertical-align: top; }
		.metric-stat { margin-left: 5px; display: block; position: relative; font-size: 150%; font-weight: 500; line-height: 100%; }
			.metric-stat-unit { font-size: 80%; line-height: 100%; opacity: 0.87; }
			.metric-stat .icon { margin-right: 5px; }
		.metric-label { margin: 0 -1px; padding: 3px 5px 2px; display: inline-block; font-size: 0.8125rem !important; font-weight: 500; letter-spacing: 0; opacity: 0.7; vertical-align: top; }

	.toggle { padding: 0 15px; position: relative; display: inline-block; color: rgba(255,255,255,0.7); cursor: pointer; font-weight: 500; line-height: 60px; -webkit-transition: color 0.1s ease; -webkit-user-select: none; user-select: none; }
		.toggle:hover { color: rgba(255,255,255,0.85); }
		.show > .toggle { top: 0; color: rgba(255,255,255,1); text-shadow: 0 1px 30px #000; }
		.widget-bottom-right:last-child .toggle { padding-right: 25px; }



		/* Message Popup */

		.message-widget-container { opacity: 0; }
		.message-pop { width: 300px; bottom: 53px; right: auto; left: 3px; z-index: 10000; display: block; opacity: 1; transition: all 0s ease; }
			.message-pop.nipple-bottom-left:before { left: 16px; opacity: 1; }

			.message-hide { height: 34px; width: 34px; font-size: 80%; line-height: 34px; text-align: center; }
			.message-pop-title { margin: 2px 0 6px; font-size: 100%; font-weight: 500; }
			.message-pop-description { margin-right: 25px; font-size: 90%; opacity: 0.8; }
			.message-pop .button { margin-top: 12px; }
			.message-pop .button-text { padding: 9px 14px; background: none; cursor: pointer; font-size: 80%; opacity: 0.6; }
				.message-pop .button-text:hover { opacity: 0.8; }



	/* Center Clock */

	#centerclock { display: inline-block; position: relative; opacity: 0; }
	#centerclock .format { position: absolute; left: 102%; bottom: 9%; font-size: 150%; opacity: 0; }
	#centerclock .show { opacity: 1; -webkit-animation: fadeout 4s ease 4s 1 normal; -webkit-animation-fill-mode: forwards; }
	#centerclock h1 { cursor: default; -webkit-user-select: none; }

	#centerclock h1, #greeting h2, #introduction, #login, #focus { text-align: center; line-height: 1; padding: 0; margin: 0; color: #fff; letter-spacing: -5px; font-size: 1125%; font-weight: 400; }
	#centerclock h1, #greeting h2 { font-weight: 500; }



	/* Greeting */

	#greeting h2, #introduction, #login, #focus { font-size: 337.5%; letter-spacing: 0; white-space: nowrap; }

	#greeting { opacity: 0; }
	#greeting .name { display: inline-block; max-width: 15em; margin: -5px 0; padding: 5px 0; border-top-left-radius: 1px; border-top-right-radius: 1px; cursor: default; outline: none; overflow: hidden; -webkit-user-select: none; user-select: none; vertical-align: top; }
	#greeting .editing { min-width: 1.5em; margin-bottom: -8px; border-bottom: 3px solid #fff; cursor: auto; }



	/* Quotes */

	.quote { height: 57px; width: 100%; margin: 0; padding-bottom: 3px; display: flex; align-items: center; text-align: center; }
		.quote-body, .quote-source { margin: 0; color: rgba(255,255,255,0.9); line-height: 120%; transition: all 0.35s ease; }

		.quote-body { width: 100%; display: block; position: relative; font-size: 18px; font-weight: 300; }
			.quote:hover .quote-body { -webkit-transform: translateY(-50%); }
			.quote-body .icon-angle-right { margin-left: 6px; font-size: 110%; opacity: 0; -webkit-transform: translateX(-8px); transition: all 0.3s ease; }

		.quote-source { position: absolute; right: 0; bottom: -29px; left: 0; font-size: 80%; opacity: 0; -webkit-transform: translateY(-20px); transition-delay: 0s; }
			.quote:hover .quote-source { opacity: 1; transition-delay: 0.2s; -webkit-transform: translateY(0); }
			.quote-source-text { margin-right: 3px; opacity: 0.75; }

			.quote-source .control { height: 16px; width: 16px; padding: 6px 2px; position: relative; display: inline-block; cursor: pointer; font-size: 110%; line-height: 100%; opacity: 0.75; vertical-align: middle; -webkit-user-select: none; user-select: none; }
				.quote-source .control:hover, .quote-source .control.active { opacity: 1; }

				.quote-source .icon { height: 16px; position: absolute; top: 4px; left: 3px; }
				.quote-source .icon-refresh { height: 14px; top: 5px; }
				.quote-source .icon-twitter { top: 5px; left: 2px; font-size: 17px; }

		.quote.has-link { cursor: pointer; }
			.quote.has-link:hover .icon-angle-right { opacity: 1; -webkit-transform: translateX(0); }
			.quote.has-link:hover .quote-body { color: #fff; }



	/* Focuses */

	#focuses { width: 100%; font-size: 187.5%; line-height: 150%; }
		#focuses::before { height: 335px; width: 100%; position: absolute; top: -115%; left: 0; z-index: -1; background: url('../../../assets/img/overlay-focus.png') no-repeat 50% 0; background-size: contain; content: ' '; }
	#focuses ol { margin: 0; padding:0; }

	#focuses .focus { height: 94px; width: 100%; position: relative; opacity: 0; display: inline-block !important; overflow: visible; }

		#focuses h3, #focuses .focus p { padding: 0; margin: 0; }

		#focuses input, #focuses .todays-focus { font-size: 120%; line-height: 120% }

		#focuses .prompt { margin-bottom: 14px; }
			#focuses .prompt h3 { font-weight: 300; }
			#focuses .prompt input { width: 13.8em; border-bottom-width: 2px; -webkit-transition: border-color .2s ease;  }

		#focuses .focus h3 { margin: 17px 0 3px; font-size: 75%; line-height: 120%; text-transform: uppercase; }
		#focuses .focus p { position: relative; }
		#focuses .todays-focus { max-width: 88%; margin: 3px 0 1px !important; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
			#focuses .complete .todays-focus { text-decoration: line-through; opacity: 0.85; }

		#focuses .control { display: inline-block; opacity: 0; border: 1px solid rgba(255,255,255,0); border-radius: 100px; cursor: pointer; -webkit-transition: all 0.1s ease-in-out; -webkit-transform-origin: 50% 50%; -webkit-user-select: none; vertical-align: top; }
			#focuses:hover .control { opacity: 0.8; }
			#focuses .complete .control { opacity: 1; }



	/* Weather */

	.weather { position: relative; cursor: pointer; }
	.weather .location { outline: none; }
	.weather .editing { border-bottom: 1px solid white; }
	.weather-degree { opacity: 0.87; }
	.weather .unit.hide { display: none; }
	.weather .unit { display: block; position: absolute; left: 97%; top: 5px; font-size: 55%; text-transform: uppercase; -webkit-animation: fadeout 4s ease 4s 1 normal; -webkit-animation-fill-mode: forwards; }
	.weather .icon-weather { line-height: 50%; }
	.weather .icon:before { font-family: 'MeteoconsRegular'; content: attr(data-icon); }
	@font-face { font-family: 'MeteoconsRegular'; src: url(data:application/font-woff2;charset=utf-8;base64,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) format('woff2'); font-weight: normal; font-style: normal; }



	/* Background Info */

	.background-info { height: 60px; width: 240px; position: absolute; bottom: 0; left: 50px; display: inline-block; font-weight: 300; transition: all 0s ease; vertical-align: bottom; cursor: pointer; }
		.background-info-title, .background-info-source { position: absolute; bottom: 0; left: 0; z-index: 1; line-height: 58px; transition: all 0.3s ease; white-space: nowrap; }
		.background-info-title { z-index: 2; font-size: 90%; opacity: 0.8; }
			.background-info:hover .background-info-title { -webkit-transform: translateY(-16%); }

		.background-info-source { font-size: 72%; opacity: 0; }
			.background-info:hover .background-info-source { -webkit-transform: translateY(16%); transition-delay: 0.2s; opacity: 1; }
			.background-info-source-link { margin-right: 4px; cursor: pointer; opacity: 0.7; transition: all 0.2s ease; }
				.background-info-source-link:hover { opacity: 0.9 !important; }

				.background-info-source-link.no-link { cursor: default; }
					.background-info-source-link.no-link:hover { opacity: 0.7 !important; }

		.background-info .icon-angle-right { margin-left: 5px; font-size: 110%; opacity: 0; -webkit-transform: translateX(-5px); transition: all 0.3s ease; }

		.background-info.has-link { cursor: pointer; }
			.background-info.has-link:hover .background-info-title { opacity: 1; }
			.background-info.has-link:hover .icon-angle-right { opacity: 1; -webkit-transform: translateX(0); }

		.background-info .control { height: 16px; width: 16px; padding: 5px 1px; position: relative; display: inline-block; cursor: pointer; font-size: 120%; line-height: 105%; opacity: 0.7; -webkit-user-select: none; user-select: none; vertical-align: middle; }
			.background-info .control:hover, .background-info .control.active { opacity: 1; }
			.background-info-source .icon { height: 15px; position: absolute; top: 5px; left: 10%; }
			.background-info-source .icon-refresh { height: 13px; top: 6px; left: 20%; }

		/*
		.background-info .control { padding: 5px 3px; cursor: pointer; font-size: 130%; opacity: 0.7; vertical-align: -2%; }
			.background-info .control:hover, .background-info .active { opacity: 1; }
			.background-info .control-next {  }
		*/



	.quicklinks { }
		.quicklinks .nipple-top-left:before { left: 26px; }
		.quicklinks .toggle { padding-right: 15px; }


	.preferences .toggle { height: 60px; padding-left: 18px; padding-right: 15px; color: rgba(255,255,255,.5); font-size: 24px; line-height: 63px; -webkit-transition: -webkit-transform 0.2s linear; }
		.preferences.has-message .toggle { color: rgba(255,255,255,.7); }
		.preferences .toggle:hover { color: rgba(255,255,255,.8); }
		.preferences.show .toggle { color: rgba(255,255,255,1); -webkit-transform: rotate(45deg); }


	/* Detail Pane */

	.settings-detail { position: relative; }

		.settings-detail-header { text-align: center; }
			.settings-detail-header h3 { font-size: 160%; }
			.settings-detail-header img { height: 24px; margin-right: 3px; vertical-align: top; }
			.settings-detail-header .description { margin: 0 0 20px; font-size: 110%; }






	/* Loading */

	.settings-loading { display: flex; align-items: center; flex-direction: column; justify-content: center; }
	.settings-loading-loading-message { font-size: 110%; }
	.settings-loading-error-message { margin: 0 0 18px; font-size: 110%; }

	/* Animations */

	.fadein { -webkit-animation: fadein 0.5s ease 0s forwards; }
		.fadein-slow { -webkit-animation-duration: 2s; }

	.softpulse { -webkit-animation: updatepulse 1s ease 0.5s 1 normal; }
	.pulse { -webkit-animation: pulse 1s ease 0s 1 normal; }
	.pulsetext { -webkit-animation: pulsetext 2.8s linear infinite; }

	@-webkit-keyframes pulsetext {
		0%, 100% { opacity: 1; }
		50% { opacity: 0.5; }
	}

	@-webkit-keyframes updatepulse {
		0% { background: rgba(255,255,255,0); }
		5% { background: rgba(255,255,255,0.6); }
		100% { background: rgba(0,0,0,0.3); }
	}

	@-webkit-keyframes pulse {
		0% { background: rgba(255,255,255,0.5); }
		100% { background: rgba(255,255,255,0); }
	}

	@-webkit-keyframes fadein { from { opacity: 0 } to { opacity: 1 } }

	@-webkit-keyframes fadeout { from { opacity: 1 } to { opacity: 0 } }

	.loading-icon { height: 14px; width: 14px; margin-right: 8px; display: inline-block; animation: loading-icon 1.4s ease infinite; background: none; border: 2px solid white; border-radius: 100%; box-sizing: border-box; vertical-align: -10%; }
	@keyframes loading-icon {
		0% { transform: scale(0); }
		15% { opacity: 1; }
		100%  { opacity: 0; transform: scale(1.5); }
	}

	@keyframes refresh {
		0%, 50.0000001% { -webkit-transform: rotate(0deg); }
		50% { -webkit-transform: rotate(180deg);}
	}



	/* Responsive */

	@media screen and (max-height: 700px) {
		body { font-size: 95%; }
	}

	@media screen and (max-height: 650px) {
		body { font-size: 90%; }
		#focuses .delete { margin-top: 9px; }
	}

	@media screen and (max-height: 600px) {
		body { font-size: 90%; }
		#center, #center-below { font-size: 90%; }
		#center-below { top: 71.5%; }
		#focuses .delete { margin-top: 8px; }
	}

	@media screen and (max-height: 550px) {
		#center, #center-below { font-size: 80%; }
		#center-below { top: 70.5%; }
	}

	@media screen and (max-height: 400px) {
		#center { top: 30%; }
		#centerclock { display: none !important; }
		#center-below { top: 52%; }
	}
</style>
